import { InjectionToken } from '@angular/core';
import type { ComponentMapping } from './transformer.model';

export const ARTICLE_COMPONENT_MAPPING: InjectionToken<ComponentMapping> = new InjectionToken<ComponentMapping>(
  'Component Mapping for Article Transformer'
);
